import { useEffect, useRef, useState } from 'react';
import { useApiIsLoaded, useMapsLibrary } from '@vis.gl/react-google-maps';

import { useQueryDetailVenue } from './useQuery';

import { ICoordinate } from '~types';

export const useGetDetailVenue = (venueId?: string) => {
  const isLoaded = useApiIsLoaded();
  const placesLib = useMapsLibrary('places');

  const placesServiceRef = useRef<google.maps.places.PlacesService | null>(
    null,
  );

  const [venueCoordination, setVenueCoordination] =
    useState<ICoordinate | null>(null);

  const venueDetailData = useQueryDetailVenue(
    { id: venueId },
    {
      enabled: !!venueId,
      refetchOnMount: true,
    },
  );

  /**
   * initial place service
   */
  useEffect(() => {
    if (!isLoaded || !placesLib) return;
    if (!placesServiceRef.current) {
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        document.createElement('div'),
      );
    }
  }, [isLoaded, placesLib]);

  useEffect(() => {
    if (!placesServiceRef.current) return;
    if (venueDetailData.data?.addressLine1) {
      placesServiceRef.current?.findPlaceFromQuery(
        {
          query: venueDetailData.data.addressLine1,
          fields: ['geometry'],
        },
        (results) => {
          const location = results?.[0]?.geometry?.location;
          if (location) {
            setVenueCoordination({
              latitude: location.lat(),
              longitude: location.lng(),
            } as ICoordinate);
          } else {
            // Bad case, can't find the coordination
            setVenueCoordination({
              latitude: 0,
              longitude: 0,
            } as ICoordinate);
          }
        },
      );
    }
  }, [isLoaded, venueDetailData.data]);

  return {
    venueDetailData,
    venueCoordination,
  };
};
